// @flow
import { useIsFetching } from '@tanstack/react-query'
import { setCompletePage } from 'pages/Slices/packetSlice'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { QUERIES } from '@/enums/queries'

type Props = { children: Function }

function FormBuilderSettingsCompletePagePacketConsumer({
  children,
}: Props): React.Node {
  const dispatch = useDispatch()
  const completePage = useSelector((state) => state.packet.completePage)

  const isFetchingUpdatePackets = useIsFetching({
    queryKey: [QUERIES.PACKETS.UPDATE],
  })
  const isFetchingAddPacket = useIsFetching({ queryKey: [QUERIES.PACKETS.ADD] })

  const updateCompletePage = React.useCallback(
    (payloadOrFunction) => {
      if (typeof payloadOrFunction === 'function') {
        const newState = payloadOrFunction(completePage)
        dispatch(setCompletePage(newState))
      } else {
        dispatch(setCompletePage(payloadOrFunction))
      }
    },
    [completePage, dispatch]
  )

  return children({
    completePage,
    setCompletePage: updateCompletePage,
    isLoading: isFetchingUpdatePackets || isFetchingAddPacket,
  })
}

export default FormBuilderSettingsCompletePagePacketConsumer
